<template>
  <v-navigation-drawer v-model="localDrawer" temporary right app width="400">
    <!-- :style="{ 'z-index': '203' }" -->
    <v-card class="pt-4 elevation-0">
      <div class="d-flex justify-end hidden-md-and-up">
        <v-btn class="ma-1" x-small outlined fixed fab right @click.stop.prevent="localDrawer = false">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </div>
    </v-card>

    <v-col v-if="isLoading && loadSaveOpened" cols="12" class="text-center py-10 mt-10">
      <v-progress-circular :size="30" indeterminate color="accent" />
      <span class="mx-2">Cargando información</span>
    </v-col>

    <template v-if="getTicket && Object.keys(getTicket).length > 1">
      <v-toolbar flat>
        <v-list-item two-line class="pa-0">
          <v-list-item-avatar size="48" color="accent" class="pa-2">
            <span class="white--text subhead"> {{ avatarText }}</span>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ getTicket.full_name }}</v-list-item-title>
            <v-list-item-subtitle>{{ getTicket.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <template #extension>
          <v-tabs v-model="tab" slider-color="primary" fixed-tabs>
            <v-tab key="1" href="#tab-1"> información </v-tab>
            <v-tab key="2" href="#tab-2"> Actividad </v-tab>
            <v-tab key="3" href="#tab-3"> Relacionado </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item key="1" value="tab-1">
          <div v-if="!editInformation" class="d-flex align-center pt-3 px-4">
            <span class="text-caption mr-2">ID OPORTUNIDAD:</span>
            <v-chip color="accent" :ripple="false" small>
              {{ getTicket.id }}
            </v-chip>
            <v-spacer />
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn color="primary" fab x-small dark v-on="on" @click.stop.prevent="editInformation = true">
                  <v-icon size="16"> fas fa-pencil-alt </v-icon>
                </v-btn>
                <!-- <v-btn size="16" fab icon small class="pa-4" color="primary">
                </v-btn> -->
              </template>
              <span>Editar información</span>
            </v-tooltip>
          </div>
          <v-form ref="formInformation" lazy-validation>
            <div class="fill-height text-center px-3 pt-2">
              <v-col v-if="editInformation" cols="12">
                <h4>Editar información de la Oportunidad</h4>
              </v-col>
              <v-col v-if="editInformation" cols="12">
                <TicketForm action="update" @cancelInformation="cancelInformation" />
              </v-col>
              <v-card v-else class="mb-4">
                <v-list v-for="(ticketField, i) in ticketFields" :key="i" class="text-left">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-regular">
                        {{
                          ticketField.type === "date"
                            ? $formatTimestamp(getTicket[ticketField.id], "format_DD/MM/YYYY")
                            : getTicket[ticketField.id]
                        }}
                        <BtnWhatsapp v-if="ticketField.id === 'phone' && getTicket.phone" :number="getTicket.phone" />
                        <BtnGmail v-if="ticketField.id === 'email' && getTicket.email" :email="getTicket.email" />
                      </v-list-item-title>
                      <v-list-item-subtitle>{{ ticketField.label }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mx-2" />
                </v-list>
              </v-card>
            </div>
          </v-form>

          <v-col v-if="getAgent.role === $roles.ENTREPRENEUR" cols="12" class="my-3">
            <v-btn text rounded color="error" @click="dialogDeleteTicket = true">Eliminar oportunidad</v-btn>
          </v-col>
        </v-tab-item>

        <v-tab-item key="2" value="tab-2">
          <v-card class="pa-2 py-4 ma-2">
            <CommentForm :ticket-id="getSelectedTicketId" :col-fixed="12" />
          </v-card>
          <v-card class="pa-2 py-4 ma-2">
            <Tags />
            <v-divider class="mt-4" />
            <Timeline :ticket-id="getSelectedTicketId" />
          </v-card>
        </v-tab-item>

        <v-tab-item key="3" value="tab-3">
          <v-card class="ma-2 pa-2">
            <CardState />
          </v-card>
          <v-card class="ma-2 pa-2">
            <CardObjection />
          </v-card>
          <v-card v-if="getProducts && getProducts.length && products" class="ma-2 pa-2">
            <div class="d-flex justify-space-between">
              <p class="font-weight-black">
                <span v-if="editProducts">EDITAR</span>
                PRODUCTOS RELACIONADOS
              </p>
              <div v-if="getTicket.state !== $ticketStates.ORDEN_CREADA" class="text-right">
                <v-tooltip v-if="getBusiness && getBusiness.ecommerce_url && products.length" bottom>
                  <template #activator="{ on }">
                    <v-btn icon small v-on="on" @click="onCopyLinkEcommerceCart(getTicket.id)">
                      <v-icon small> fas fa-link </v-icon>
                    </v-btn>
                  </template>
                  <span>Copiar link de carrito</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn icon small v-on="on" @click="addItemProduct">
                      <v-icon small> fas fa-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar producto</span>
                </v-tooltip>
              </div>
            </div>
            <v-form ref="formProducts" lazy-validation>
              <ItemsProducts
                :products.sync="products"
                :discount.sync="discount"
                :action.sync="actionItemsProducts"
                :total-delivery.sync="getTicket.total_delivery"
              />
              <v-col v-if="editProducts" cols="12" class="text-center">
                <v-btn :loading="loadSaveProducts" small rounded color="primary" @click="saveTicketProducts">
                  Guardar
                </v-btn>
                <v-btn small rounded @click="cancelProducts"> Cancelar </v-btn>
              </v-col>
            </v-form>
          </v-card>
          <v-card class="ma-2 pa-2">
            <CardAgent />
          </v-card>
          <!--
          <v-card class="ma-2 pa-2">
            <p class="font-weight-black">ASISTENCIA</p>
            <v-col cols="12" class="d-flex">
              <div v-if="getTicket.agent_id && !loadSaveAgent">
                <v-avatar size="48px" color="black">
                  <img
                    v-if="getAllAgentsMap[getTicket.agent_id].photo"
                    :src="getAllAgentsMap[getTicket.agent_id].photo"
                    alt="Avatar"
                  />
                  <span v-else class="white--text text-h5">
                    {{ getAllAgentsMap[getTicket.agent_id].full_name.substring(0, 1) }}
                  </span>
                </v-avatar>
              </div>
              <div v-else>
                <v-avatar size="50px" color="black">
                  <span class="white--text text-h5">-</span>
                </v-avatar>
              </div>
              <v-text-field
                v-if="[$roles.ADVISOR].includes(getAgent.role) || getTicketStatesMap[getTicket.state].final"
                v-model="getAgent.full_name"
                label="Agente"
                class="pl-2"
                readonly
              />
              <v-autocomplete
                v-else
                v-model="agentTicket"
                :items="getAgentsToArray"
                :disabled="loadSaveAgent"
                :value="getTicket.agent_id"
                :loading="loadSaveAgent"
                item-text="full_name"
                item-value="uid"
                label="Agente"
                placeholder="Sin asignar"
                class="pl-2 w95"
              />
            </v-col>
          </v-card>
          -->
          <v-card
            v-if="!hideOriginForAdvisors || ![$roles.ADVISOR, $roles.ADVISOR_LEVEL2].includes(getAgent.role)"
            class="ma-2 pa-2"
          >
            <p class="font-weight-black">FUENTE</p>

            <v-col class="size" cols="12">
              <div>
                Obtenido desde <strong>{{ getTicket.origin }}</strong>
              </div>
            </v-col>
            <v-col v-if="getTicket.created_uid && getAllAgentsMap[getTicket.created_uid]" class="d-flex" cols="12">
              <div>
                <v-avatar size="50px" color="black">
                  <img
                    v-if="getAllAgentsMap[getTicket.created_uid].photo"
                    :src="getAllAgentsMap[getTicket.created_uid].photo"
                    alt="Avatar"
                  />
                  <span v-else class="white--text text-h5">
                    {{ getAllAgentsMap[getTicket.created_uid].full_name.substring(0, 1) }}
                  </span>
                </v-avatar>
              </div>
              <v-text-field
                :value="getAllAgentsMap[getTicket.created_uid].full_name"
                label="Registrado por:"
                class="pl-2 w95"
                readonly
              />
            </v-col>
          </v-card>

          <v-card v-if="getTicket.wa_source_id" class="pa-2 ma-2">
            <div class="d-flex justify-space-between">
              <p class="font-weight-black mb-2">ANUNCIO RELACIONADO</p>
            </div>

            <CardAd class="ma-2" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <ModalDeleteTicket
      v-if="dialogDeleteTicket"
      :id="getTicket.id"
      :dialog.sync="dialogDeleteTicket"
      :from-drawer="true"
      @onComplete="localDrawer = false"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "Config/config";

import TicketForm from "./forms/Ticket";
import Timeline from "@/components/tickets/Timeline";
import CommentForm from "@/components/tickets/CommentForm";
import Tags from "./options/Tags";
import BtnWhatsapp from "@/components/buttons/BtnWhatsapp";
import BtnGmail from "@/components/buttons/BtnGmail";
import ItemsProducts from "@/components/items/Products";
import CardState from "@/views/tickets/cards/State";
import CardObjection from "@/views/tickets/cards/Objection";
import CardAgent from "@/views/tickets/cards/Agent";
import CardAd from "@/views/tickets/cards/Ad";
import ModalDeleteTicket from "@/views/tickets/modals/Delete";

export default {
  name: "TicketDetailDrawer",
  components: {
    TicketForm,
    Tags,
    Timeline,
    CommentForm,
    BtnWhatsapp,
    BtnGmail,
    ItemsProducts,
    CardState,
    CardObjection,
    CardAgent,
    CardAd,
    ModalDeleteTicket,
  },
  data() {
    return {
      isLoading: true,
      loadSaveOpened: true,
      tab: "tab-2",
      ticket: {
        id: this.getSelectedTicketId,
      },
      tabs: [0, 1, 2],
      ticketFields: [],
      editInformation: false,
      editContact: false,
      editProducts: false,
      loadProducts: false,
      loadSaveInformation: false,
      loadSaveAgent: false,
      loadSaveProducts: false,
      state: null,
      products: null,
      discount: null,
      resetProducts: false,
      hideOriginForAdvisors: config.hideOriginForAdvisors,
      dialogDeleteTicket: false,
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedTicketId",
      "getShowTicketDetailDrawer",
      "getShowTicketDetailDrawerSection",
      "getAgent",
      "getAllAgentsArray",
      "getAllAgentsMap",
      "getAgentsToArray",
      "getTicket",
      "getActiveTicketStates",
      "getTicketStatesMap",
      "getTimeline",
      "getContact",
      "getSchemaTicketForm",
      "getProducts",
      "getBusiness",
    ]),
    localDrawer: {
      get() {
        return this.getShowTicketDetailDrawer;
      },
      set(v) {
        if (!v) {
          this.ticketFields = [];
          this.editInformation = false;
          this.editContact = false;
          this.loadSaveInformation = false;
          this.loadSaveTags = false;
          this.loadSaveAgent = false;
          this.tags = [];
          this.state = 0;
          // this.showTicketDetail({ ticketId: null });
          this.hideTicketDetail();
        }
      },
    },
    agentTicket: {
      get() {
        return this.getTicket != null ? this.getTicket.agent_id : 0;
      },
      set(value) {
        if (this.getTicket.agent_id !== value) this.saveAgent(value);
      },
    },
    entity() {
      return this.getContact || this.getTicket;
    },
    avatarText() {
      if (!this.getTicket || (!this.getTicket.name && !this.getTicket.last_name)) return "";

      return `${this.getTicket.name.charAt(0)}${
        this.getTicket.last_name ? this.getTicket.last_name.charAt(0) : ""
      }`.toUpperCase();
    },
    allowUpdateItemsProducts() {
      return this.getTicket.state !== this.$ticketStates.ORDEN_CREADA;
    },
    actionItemsProducts() {
      return this.allowUpdateItemsProducts ? "update" : "read";
    },
  },
  watch: {
    "getTicket.state"(value) {
      if (value === this.$ticketStates.ORDEN_CREADA) {
        this.resetProducts = true;
        this.editProducts = false;
        this.products = (this.getTicket.products || []).map((p) => ({
          ...p,
          attributes: (p.attributes || []).map((a) => ({ ...a })),
        }));
      }
    },
    getTicket(value, oldValue) {
      if (!value) return;

      if (!this.products)
        this.products = (value.products || []).map((p) => ({
          ...p,
          attributes: (p.attributes || []).map((a) => ({ ...a })),
        }));

      if (!this.state) this.state = value.state;

      if (!this.discount) this.discount = value.discount || 0;

      if (!oldValue && this.getAgent.uid === value.agent_id) this.setTicketOpened({ id: this.getSelectedTicketId });
      this.loadSaveOpened = false;
    },
    discount(value) {
      if (this.getTicket?.discount !== value && !this.resetProducts) this.editProducts = true;
    },
    products: {
      deep: true,
      handler(value, oldValue) {
        if (oldValue && this.allowUpdateItemsProducts && !this.resetProducts) this.editProducts = true;
        else {
          this.editProducts = false;
          this.resetProducts = false;
        }
      },
    },
  },
  created() {
    this.mountedNow();
  },
  methods: {
    ...mapActions([
      "getAllAgents",
      "getAllProducts",
      "getAllTicketStates",
      "showTicketDetail",
      "hideTicketDetail",
      "getTicketById",
      "getTeamSchema",
      "setTicketAgent",
      "setTicketProducts",
      "setTicketOpened",
    ]),
    async mountedNow() {
      if (!this.getProducts) await this.getAllProducts();
      if (!this.getActiveTicketStates) await this.getAllTicketStates();
      if (!this.getAllAgentsArray) await this.getAllAgents();

      await this.getTicketById({ ticket_id: this.getSelectedTicketId });

      this.initSchemas();

      this.isLoading = false;
    },
    async initSchemas() {
      let ticketFormSchema = config.ticketFormSchema;

      if ([this.$roles.ENTREPRENEUR, this.$roles.ADVISOR_LEVEL2, this.$roles.SUPERVISOR].includes(this.getAgent.role)) {
        await this.getTeamSchema({ id: "ticket_form" });
        ticketFormSchema = this.getSchemaTicketForm;
      }

      this.ticketFields = this.loadSchemaFields(ticketFormSchema);
    },
    loadSchemaFields(schema) {
      return schema.filter((sf) => sf.show_on_detail);
    },
    cancelInformation() {
      this.editInformation = false;
    },
    cancelContact() {
      this.editContact = false;
    },
    async saveAgent(agent_id) {
      try {
        this.loadSaveAgent = true;

        await this.setTicketAgent({ ticket_id: this.getTicket.id, agent_id: agent_id });
      } catch (error) {
        console.error("ticket/saveAgent: ", error);
        this.agentTicket = this.getTicket.agent_id;
      } finally {
        this.loadSaveAgent = false;
      }
    },
    addItemProduct() {
      this.products.push({
        id: "",
        name: "",
        price: 0,
        quantity: 1,
        attributes: [],
      });
    },
    async saveTicketProducts() {
      try {
        this.loadSaveProducts = true;

        if (!this.$refs.formProducts.validate()) return;

        await this.setTicketProducts({ id: this.getTicket.id, products: this.products, discount: this.discount });

        this.editProducts = false;
      } catch (error) {
        console.error("saveTicketProducts: ", error);
      } finally {
        this.loadSaveProducts = false;
      }
    },
    cancelProducts() {
      this.resetProducts = true;
      this.products = (this.getTicket.products || []).map((p) => ({
        ...p,
        attributes: (p.attributes || []).map((a) => ({ ...a })),
      }));
      this.discount = this.getTicket.discount || 0;
    },
    onCopyLinkEcommerceCart(opportunityId) {
      let link = document.createElement("input");
      link.setAttribute("type", "text");
      link.setAttribute("value", `${this.getBusiness?.ecommerce_url}/checkout?id=${opportunityId}`);
      document.body.appendChild(link);
      link.select();
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      link.setAttribute("type", "hidden");
    },
  },
};
</script>
